var _excluded = ["id"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import classnames from 'classnames';
import FilePicker from '../../file-picker';
import FilePondClient from './filepond-client';
import { LinkOutlined } from '@ant-design/icons';
import { Input } from 'antd';

var FilePondProvider = function FilePondProvider(_ref) {
  var id = _ref.id,
      props = _objectWithoutProperties(_ref, _excluded);

  // primary ids
  var fpId = "filepond-provider-".concat(id);
  var editorContainerSelector = "".concat(fpId, "-pintura-editor-container");
  React.useEffect(function () {
    console.debug('[FilePicker] using FilePondProvider', fpId);
  }, []);

  var _React$useState = React.useState(),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      inputValue = _React$useState2[0],
      setInputValue = _React$useState2[1];

  var _React$useState3 = React.useState(),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      search = _React$useState4[0],
      setSearch = _React$useState4[1];

  var sharedFilePondClientConfig = _objectSpread(_objectSpread({}, props), {}, {
    editorContainerSelector: ".".concat(editorContainerSelector)
  });

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(FilePicker, {
    onSourceChange: function onSourceChange(type) {
      if (type !== FilePicker.Url.type) {
        // clear url module form
        setInputValue(undefined);
        setSearch(undefined);
      }
    },
    handleClose: props.handleClose
  }, /*#__PURE__*/React.createElement(FilePicker.MyDevice, null, /*#__PURE__*/React.createElement(FilePondClient, _extends({
    id: fpId
  }, sharedFilePondClientConfig))), /*#__PURE__*/React.createElement(FilePicker.Url, null, search === undefined ? /*#__PURE__*/React.createElement(Input.Search, {
    className: "swfp-url-input",
    placeholder: "Enter a URL",
    enterButton: /*#__PURE__*/React.createElement(LinkOutlined, null),
    value: inputValue,
    onChange: function onChange(ev) {
      return setInputValue(ev.target.value);
    },
    onSearch: function onSearch(url) {
      setSearch(url);
      setInputValue(undefined);
    }
  }) : /*#__PURE__*/React.createElement(FilePondClient, _extends({
    id: "".concat(fpId, "-url")
  }, sharedFilePondClientConfig, {
    onEmpty: function onEmpty() {
      return setSearch(undefined);
    },
    defaultValue: {
      url: search
    }
  })))), /*#__PURE__*/React.createElement("div", {
    className: classnames('pintura-image-editor-container', editorContainerSelector)
  }));
};

export default FilePondProvider;